import { db } from "../services/Firebase"
import { whiteWine, redWine, desertWine, sparklingWine } from "../constants/Wine"

const recipeRef = db.collection( "randomRecipes" )
const wineRef = db.collection( "randomWine" )

const handleFetchAndStoreFS = () => {
    const getWineName = (() => {
        const { dryWhiteWine, otherWhiteWine } = whiteWine
        const { dryRedWine, otherRedWine } = redWine
        const { dWine } = desertWine
        const { sWine } = sparklingWine
        const getIndex = ( wine ) => Math.floor( Math.random() * wine.length ) + 1
        const names = [ 
            dryWhiteWine[getIndex(dryWhiteWine)],
            otherWhiteWine[getIndex(otherWhiteWine)],
            dryRedWine[getIndex(dryRedWine)], 
            otherRedWine[getIndex(otherRedWine)],
            dWine[getIndex(dWine)],
            sWine[getIndex(sWine)]
        ]
        const getName = () => Math.floor( Math.random() * names.length ) + 1
        return names[getName()]
    })()

    const url = "https://api.spoonacular.com"
    const recipeParam = "/recipes/random?number=3"
    const wineParam = `/food/wine/recommendation?wine=${getWineName}&number=3`
    const apiKey = `&apiKey=${process.env.REACT_APP_SPOONACULAR_API_KEY}`

    Promise.all([
        fetch( url + recipeParam + apiKey ),
        fetch( url + wineParam + apiKey )
    ])
        .then( responses => Promise.all( responses.map(res => res.json()) ) )
        .then( data => {
        // console.log(data)
            data && storeDataFS( data[0].recipes, data[1].recommendedWines )
        // data && storeData( "randomRecipes", data[0].recipes )
        // data && storeData( "randomWine", data[1].recommendedWines )
        })
        .catch( err => console.log(err) )
}

const storeDataFS = (recipes, wine) => {
    !wine && !recipes && console.log("Didn't store")
    let randomRecipes = [...new Set(recipes)]
    let randomWine = [...new Set(wine)]

    randomRecipes.map(item => {
        console.log("Recipes added to Firestore")
        return recipeRef.add({
            created: Date.now(),
            vegetarian: item.vegetarian,
            vegan: item.vegan,
            glutenFree: item.glutenFree,
            dairyFree: item.dairyFree,
            id: item.id,
            title: item.title,
            readyInMinutes: item.readyInMinutes,
            servings: item.servings,
            image: item.image,
            summary: item.summary,
            dishTypes: item.dishTypes,
            instructions: item.instructions,
            analyzedInstructions: item.analyzedInstructions,
            extendedIngredients: item.extendedIngredients,
            cuisines: item.cuisines
        })
    })

    randomWine.map(item => {
        console.log("Wine added to Firestore")
        return wineRef.add({
            created: Date.now(),
            id: item.id,
            title: item.title,
            description: item.description,
            price: item.price,
            averageRating: item.averageRating,
            imageURL: item.imageUrl
        })
    })
}

const getDataFromFS = ( setLoading, setStoredRecipes, setStoredWine ) => {
    setLoading(true)
    let recipes = []
    let wine = []
    recipeRef.onSnapshot(snapShot => {
        snapShot.forEach(doc => {
            recipes.push(doc.data())
        })
    })
    wineRef.onSnapshot(snapShot => {
        snapShot.forEach(doc => {
            wine.push(doc.data())
        })

        const recipeSet = [...new Set(recipes)]
        const wineSet = [...new Set(wine)]

        shuffleArray(recipeSet)
        const partRecipe = recipeSet.splice(0, 3)
        setStoredRecipes(partRecipe)

        shuffleArray(wineSet)
        const partWine = wineSet.splice(0, 3)
        setStoredWine(partWine)
        setLoading(false)
    })
}

const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        const temp = array[i]
        array[i] = array[j]
        array[j] = temp
    }
}

const handleFetchAndStoreLS = ( query, setAllRecipes ) => {
    const url = "https://api.spoonacular.com"
    const recipeParam = `/recipes/complexSearch?query=${query}&instructionsRequired=true&fillIngredients=true&addRecipeInformation=true&addRecipeNutrition=true&number=6`
    const apiKey = `&apiKey=${process.env.REACT_APP_SPOONACULAR_API_KEY}`

    fetch(url + recipeParam + apiKey)
        .then(res => res.json())
        .then(data => {
            console.log("start fetching")
            localStorage.removeItem("searchRecipes")
            data && setAllRecipes(data.results)
            data && storeData("searchRecipes", data.results)
        })
        .catch(err => console.log(err))
}

const storeData = (key, data) => localStorage.setItem(key, JSON.stringify(data))

const getDataFromLS = (key) => JSON.parse(localStorage.getItem(key)) || []

const Service = {
    recipeRef,
    wineRef,
    handleFetchAndStoreFS,
    getDataFromFS,
    storeData,
    handleFetchAndStoreLS,
    getDataFromLS
}

export default Service